import styled from 'styled-components';
import Theme from 'app/theme';
// Message Wrapper
export const MessageWrapper = styled.div`
    display: flex;
    flex-direction: row;
`;

export const Text = styled.div`
    align-self: flex-end;
    padding-bottom: 0.25rem;
    margin-left: 0.75rem;
`;

export const Icon = styled.div`
    width: 2.5rem;
    height: 2.5rem;

    svg {
        fill: white;
    }
`;

export const Message = styled.div`
    line-height: 1.5rem;
`;

export const MultipleMessagesWrapper = styled.div`
    display: flex;
    width: 100%;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    ${Icon} {
        margin-bottom: 1rem;
    }

    ${Text} {
        align-self: auto;
        text-align: center;
    }
`;

export const BoxTitleWrapper = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 1rem;
`;

export const BoxTitle = styled.div`
    font-size: 1.5rem;
`;

export const IconTitle = styled.div`
    width: 1.25rem;
    display: inline-block;
    margin-right: 4px;

    svg {
        fill: white;
    }
`;

export const Tick = styled.div`
    margin-left: 0.5rem;
    background-color: white;
    color: ${Theme.COLORS.PRIMARY_L2};
    padding: 2px 5px;
    border-radius: 25px;
    font-size: 0.75rem;
`;
